import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

class AssetTagsList extends React.Component {
    render () {
        const { tagWithoutSpaces, assetTags, tags, classes, onTagSelected, preserveOrder } = this.props;

        const availableTags = tagWithoutSpaces ? tags.filter((tag) => tag.indexOf(tagWithoutSpaces) !== -1) : tags;

        let tagsList;
        
        if (preserveOrder) {
            // Don't reorder tags when preserveOrder is true (used in BatchTagModal)
            tagsList = availableTags.map((availableTag, idx) => {
                const assetTagIndex = assetTags.indexOf(availableTag);
                const isAlreadySelected = assetTagIndex !== -1;
                return (
                    <div
                        key={`tag-${availableTag}-${idx}`}
                        className={classes.tagItem}
                        onClick={() => onTagSelected(availableTag, assetTagIndex, isAlreadySelected)}
                    >
                        <i className="material-icons">{isAlreadySelected ? 'check_box' : 'check_box_outline_blank'}</i>
                        <span className={classes.tagName} title={availableTag}>{availableTag}</span>
                    </div>
                );
            });
        } else {
            tagsList = availableTags.reduce((currentTagsList, availableTag, idx) => {
                const assetTagIndex = assetTags.indexOf(availableTag);
                const isAlreadySelected = assetTagIndex !== -1;
                const tagItem =
                    (<div
                        key={`tag-${availableTag}-${idx}`}
                        className={classes.tagItem}
                        onClick={() => onTagSelected(availableTag, assetTagIndex, isAlreadySelected)}
                    >
                        <i className="material-icons">{isAlreadySelected ? 'check_box' : 'check_box_outline_blank'}</i>
                        <span className={classes.tagName} title={availableTag}>{availableTag}</span>
                    </div>);
                if (isAlreadySelected) {
                    currentTagsList.unshift(tagItem);
                } else {
                    currentTagsList.push(tagItem);
                }
                return currentTagsList;
            }, []);
        }

        return (
            <div className={classes.tags}>
                {tagsList}
            </div>
        );
    }
};

AssetTagsList.propTypes = {
    tagWithoutSpaces: PropTypes.string.isRequired,
    assetTags: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    preserveOrder: PropTypes.bool,
};

AssetTagsList.defaultProps = {
    preserveOrder: false
};

const style = ({ palette }) => ({
    tags: {
        display: 'flex',
        alignItems: 'start',
        maxHeight: 260,
        marginTop: 10,
        flexDirection: 'column',
        overflow: 'auto',
    },
    tagItem: {
        padding: '5px 25px',
        width: 235,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: palette.background.gray3Color,
        }
    },
    tagName: {
        paddingLeft: 10,
        maxWidth: 200,
        overflow: 'hidden',
        whiteSpace: 'nowrap', 
        textOverflow: 'ellipsis'
    },
});

export default injectSheet(style)(AssetTagsList);



// WEBPACK FOOTER //
// ./src/components/modals/AssetTagsList.js